import './style.scss'
import React, { useEffect, useState } from 'react'
import { Row, Col } from 'reactstrap'
import SidePopup from 'components/SidePopup'
import { connect, useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { marketingAct } from 'redux/actions'
import { I18n } from 'react-redux-i18n'
import moment from 'moment'

import { MARKETING } from 'constants/index'
import { marketing } from 'api'
import { getStaticImage } from 'utils/statics'
import PhoneViewer from 'components/PhoneViewer'
import { TextNumberFormat } from 'components/Form'
import CampaignDetailButtons from './CampaignDetailButtons'
import Nixi1Spinner from 'components/Nixi1Spinner'
const _ = require('lodash')


const CampaignDetails = (props) => {
  const { history, match, company } = props
  const dispatch = useDispatch()

  const [currentTemplate, setCurrentTemplate] = useState('')

  const { params: { id } } = match
  const templates = useSelector((store) => store.marketing.templates)
  const templateButtons = useSelector((store) => store.marketing.buttons)
  const variables = useSelector((store) => store.marketing.templates.variables)
  const [template, setTemplate] = useState({})
  const [campaign, setCampaign] = useState({})
  const [isFetching, setIsFetching] = useState(true)

  useEffect(() => {
    marketing
      .getCampaign(id)
      .then(({ data, status }) => {
        setIsFetching(false)
        if (status === 200) {
          setCampaign({ ...data.result })
        }
      })
      .catch(error => {
        setIsFetching(false)
        console.error(error)
      })
    Promise.all([dispatch(marketingAct.getTemplateVariables()), dispatch(marketingAct.getAllTemplates(false))]).catch(console.error)
  }, [dispatch, id])
  useEffect(() => {
    if (currentTemplate !== '') {
      template.buttons = templateButtons
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [templateButtons, campaign, variables, currentTemplate])

  useEffect(() => {
    if (currentTemplate === '' && campaign && templates) {
      if (campaign.templates?.length > 0) {
        const _template = templates[campaign.templates[0]?.channel]?.find((tem) => tem._id === campaign.templates[0].templateId)
        setCurrentTemplate(campaign.templates[0].channel)
        setTemplate({ ..._template })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campaign, templates])

  const channels = (template, index) => {
    let channel = template.channel
    let label = 'channels_messenger'

    if (channel === 'whatsapp') label = `channels_twilio_whatsapp`
    else if (channel === 'chatmail') label = `channels_chatmail`
    else if (channel === 'sms') label = `channels_sms`
    else if (channel === 'telegram') label = `channels_telegram`
    else if (channel === 'chatweb') label = `channels_chatweb`
    else if (channel === 'android') label = `channels_android`
    else if (channel === 'ios') label = `channels_wall_ios`
    else if (channel === 'whatsapp_whatsapp') {
      channel = 'whatsapp'
      label = 'channels_whatsapp_whatsapp'
    }

    return (
      <li
        key={index}
        className={currentTemplate === template.channel ? 'active' : ''}
        onClick={() => {
          const _template = templates[template.channel]?.find((tem) => tem._id === template.templateId)
          setCurrentTemplate(template.channel)
          setTemplate({ ..._template })
        }}
      >
        <img src={`${getStaticImage(`/channels/orange-brand/${channel}-icon.svg`)}`} alt={channel} className={`mkt-campaign-ch-img ${channel}`} />
        {I18n.t(label)}
      </li>
    )
  }

  return (
    <SidePopup onHide={() => history.push(match.path.replace('/:id', ''))}>
      <Row>
        <div className='section-title'>{I18n.t('campaign_detailed')}</div>
      </Row>
      {campaign._id ? (
        <div className={'animated fadeIn'}>
          <Row>
            <div className='section-subtitle'>{I18n.t('campaign_basic_information')}</div>
          </Row>
          <Row>
            <div className='details_row'>
              <strong>{I18n.t('dashboard_campaign')}:</strong> {campaign.name}
            </div>
          </Row>
          <Row>
            <div className='details_row'>
              <strong>{I18n.t('dashboard_duration')}:</strong> {campaign.duration} {campaign.durationLabel}
            </div>
          </Row>
          <Row>
            <div className='details_row'>
              <strong>{I18n.t('dashboard_cost')}:</strong> <TextNumberFormat defaultValue={campaign.cost} inputOrText='text' /> {campaign.costCurrency}
            </div>
          </Row>
          <Row>
            <div className='details_row'>
              <strong>{I18n.t('dashboard_occasion-id')}:</strong> {campaign.ocasionId}
            </div>
          </Row>
          <Row>
            <div className='details_row'>
              <strong>{I18n.t('dashboard_occasion-name')}:</strong> {campaign.ocasionName}
            </div>
          </Row>
          <Row>
            <div className='details_row'>
              <strong>{I18n.t('dashboard_creation-date')}:</strong> {moment(campaign.createdAt).format('YYYY-MM-DD')}
            </div>
          </Row>
          <Row>
            <div className='details_row'>
              <strong>{I18n.t('dashboard_start-date')}:</strong> {moment(campaign.startDate).format('YYYY-MM-DD')}
            </div>
          </Row>
          <Row>
            <div className='details_row'>
              <strong>{I18n.t('dashboard_finish-date')}:</strong> {moment(campaign.endDate).format('YYYY-MM-DD')}
            </div>
          </Row>
          <Row>
            <div className='details_row'>
              <strong>{I18n.t('dashboard_state')}:</strong> {I18n.t(MARKETING.status[campaign.state] || 'state')}
            </div>
          </Row>
          <Row>
            <div className='details_row'>
              <strong>{I18n.t('dashboard_manager')}:</strong> {_.get(campaign, ['createdByName', '0', 'fullname'])}
            </div>
          </Row>
          {
            _.get(campaign, ['facebookCampaign', 'pages'])?.length
              ? (
                <>
                  <Row>
                    <div className='details_row'>
                      <strong>{I18n.t('campaign_listing_facebook_status')}</strong>
                    </div>
                  </Row>
                  {_.get(campaign, ['facebookCampaign', 'pages']).map((it, index) => (
                    <div key={'status' + index}>
                      {it.status && (
                        <Row>
                          <div className='details_row'>
                            <strong>Estado: </strong> {I18n.t(`status_${it.status}`)}
                          </div>
                        </Row>
                      )}
                      {it.status === MARKETING.statusFromFacebook.WITH_ISSUES && it.errorNotices ? (
                        <Row>
                          <div className='details_row error-facebook'>{`${it.errorNotices.errorCode} - ${it.errorNotices.errorMessage}`}</div>
                        </Row>
                      ) : null}
                    </div>
                  ))}
                </>
              )
              : null
          }
          {
            campaign.templates?.length > 0
              ? (
                <>
                  <Row>
                    <div className='section-subtitle'>{I18n.t('campaign_template_information')}</div>
                  </Row>
                  <Row className='details-templates details_row overflow-hidden'>
                    <Col md={6}>
                      <ul className='templates-list'>{campaign.templates.map((it, index) => channels(it, index))}</ul>
                    </Col>
                    {currentTemplate !== '' && (
                      <Col md={6} className='phone-viewer'>
                        <PhoneViewer key={`key-${currentTemplate}`} variables={variables} channel={currentTemplate} company={company} textPreview={template} origin='marketing' />
                      </Col>
                    )}
                  </Row>
                </>
              ) : null
          }
          <CampaignDetailButtons
            state={campaign.state}
            campaign={campaign}
          />
        </div>
      ) : (
        <>
          {isFetching ? (
            <Nixi1Spinner width='1rem' height='1rem' />
          ) : (
            !campaign._id && (
              <Row>
                <div className='details_row'>{'No existen datos para la consulta'}</div>
              </Row>
            )
          )}
        </>
      )}
    </SidePopup>
  )
}

export default connect((state) => ({
  marketing: state.marketing,
  company: state.marketing.templates.company,
}))(withRouter(CampaignDetails))
